export default "__VITE_ASSET__Dvmrt2Mb__"